import { AlertInfoIcon, Button, Theme } from '@spoiler-alert/ui-library';
import React from 'react';

import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  bannerContainer: {
    width: '-webkit-fill-available',
    bottom: '75px',
    display: 'flex',
    justifyContent: 'center',
  },
  banner: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'space-between',
    bottom: 75,
    backgroundColor: Theme.textColorPrimary,
    borderRadius: '4000px',
    padding: '24px',
    width: '80%',
    maxWidth: '1400px',
    margin: 'auto',
    zIndex: '21',
    boxShadow: '0 7px 20px 0 rgba(0, 0, 0, 0.32)',
  },
  bannerInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  bannerIcon: {
    width: 36,
    height: 36,
    fill: Theme.white,
    marginRight: 12,
  },
  bannerText: {
    color: Theme.white,
    '& h1': {
      fontSize: 20,
      fontWeight: 'bold',
      margin: 0,
      lineHeight: '1.44',
    },
    '& h2': {
      fontSize: 18,
      fontWeight: 'normal',
      margin: 0,
      lineHeight: '1.44',
    },
  },
  button: {
    borderRadius: '4000px',
    color: Theme.textColorPrimary,
    padding: 20,
    fontSize: 16,
    fontWeight: 600,
  },
});

// Shown when the polling query reports that this tab's truck lanes are no longer in the user's current
// site/transaction cycle - e.g. the user impersonated another site in a different tab, or the cycle
// rolled over while the page was open. Nothing on the page can recover from that, so ask for a reload.
const StaleTabBanner = () => {
  const classes = useStyles();

  return (
    <div className={classes.bannerContainer}>
      <div className={classes.banner}>
        <div className={classes.bannerInfo}>
          <AlertInfoIcon className={classes.bannerIcon} />
          <div className={classes.bannerText}>
            <h1>This page is out of date</h1>
            <h2>Refresh the page to see the latest data.</h2>
          </div>
        </div>
        <div>
          <Button secondary className={classes.button} onClick={() => window.location.reload()}>
            Refresh page
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StaleTabBanner;
